<template>
  <div v-if="zbozi.active" class="mb-1">
    <div class="form-check">
      <input id="dm_zbozi_consent_checkbox" type="checkbox" class="form-check-input" :checked="zbozi.checked" @change="updateValue">
      <label class="form-check-label" for="dm_zbozi_consent_checkbox">
        {{ zbozi.text }}
        <span v-if="zbozi.showLink">
          <a :href="zbozi.link" target="_blank" class="dm_zbozi_consent_link">{{ zbozi.linkName }}</a>
        </span>
      </label>
    </div>
  </div>
</template>

<script>
import {mapState} from 'vuex';

export default {
  computed: {
    ...mapState({
      zbozi: state => state.dmZboziConsent,
    }),
  },
  methods: {
    updateValue (e) {
      this.$store.commit('dmZboziConsent/SET', e.target.checked);
    }
  },
};
</script>

<style scoped>
  .dm_zbozi_consent_link {
    text-decoration: underline;
  }
</style>
